import { UserDto, UsersApi } from '../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseSearchUser = ({
  usersApi,
} : {
  usersApi: UsersApi,
}) => UseMutationResult<AxiosResponse<UserDto[]>, ErrorResponse, string>;

export const useListUsers: UseSearchUser = ({
 usersApi,
}) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    (externalId: string) => usersApi.listUsers(tenantId, undefined, externalId, true),
  );
};
